Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.commonFields = void 0;
exports.commonFields = {
  __typename: {
    system: true,
    type: 'shortText'
  },
  title: {
    initialContent: '%Component name% generated by boilerplate',
    required: true,
    translations: {
      name: {
        'en-US': 'Title within Contentful',
        nl: 'Titel binnen Contentful'
      },
      helpText: {
        'en-US': 'Only used within Contentful, does not appear on the site itself',
        nl: 'Alleen gebruikt in Contentful, wordt nooit getoond op de site zelf'
      }
    },
    type: 'shortText'
  }
};